<div class="nav-bar" [ngClass]="{'change-mobile' : !skipMobileView}">
  <div (click)="clickNav()" class="back-button-container" >
    <span class=" material-icons back-icon ">arrow_back_ios</span>
    <h5>Zurück</h5>
  </div>
</div>
